import React from 'react'
import '../../assets/css/dataTable.css'

export default function DataTableWrapper({children, tableID, tableName, tableButtons}) {
  return (
    <div className="card card-default">
  <div style={{rowGap: '0.9rem'}} className="card-header border-bottom d-flex align-items-center justify-content-between flex-wrap">
    <h5>{tableName}</h5>
    {tableButtons && <>{tableButtons}</>}
  </div>
  <div className="card-body">
    <table id={tableID} className="table table-striped table-product" style={{width:"100%"}}>
      {children}
    </table>

  </div>
</div>
  )
}
